import { Injectable } from '@angular/core';
import { UtilsService } from './utils.service';
import { environment } from 'src/environments/environment';
import { ApiUrlService } from 'src/services/api-url.service';
import { FetchService } from './fetch.service';

@Injectable({
    providedIn: 'root'
})
export class SolicitudesService {

    firestoreSubscription;

    constructor(public utils: UtilsService, private localFetch: FetchService, private apiUrlService: ApiUrlService) {

    }

    async getSolicitudes() {
        const response = await this.localFetch.getFetch(this.apiUrlService.baseUrl + '/requests');
        this.markRequestOpenedIfNeeded(response);

        return response;
    }

    async getSolicitudByCode(vcCode) {
        const response = await this.localFetch.freeGetFetch(this.apiUrlService.baseUrl + '/requests/' + vcCode);
        this.markRequestOpenedIfNeeded(response);

        return response;
    }

    setPhone(obj, reqID) {
        return new Promise((resolve, reject) => {
            this.localFetch.putFetchWhitoutToken(`${this.apiUrlService.baseUrl}/requests/${reqID}/person` , obj).then(d => {
                
                if(d) {
                    this.sendMessageToParent({ type: "response", data: d.data || d })
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                reject(e);
            })
        });
    }

    noPhone(obj) {
        return new Promise((resolve, reject) => {
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + '/requests/sms/no-phone' , obj).then(d => {
                if(d) {
                    this.sendMessageToParent({ type: "response", data: d.data || d })
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                reject(e);
            })
        });
    }

    smsToPin(obj) {
        return new Promise((resolve, reject) => {
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + '/requests/sms-clave' , obj).then(response => {
              if (response) {
                    const requestId = (response.data || response).request_id;
                    this.markRequestOpenedIfNeeded(requestId); 
                    this.sendMessageToParent({ type: "response", data: response.data || response })
                    resolve(response);
                } else {
                    reject(response)
                }
            }).catch(e => {
                reject(e);
            })
        });
    }

    
    addSolicitud(solicitud) {
        
        return new Promise((resolve, reject) => {
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + '/requests/sms' , solicitud).then(response => {
                if(response) {
                    this.sendMessageToParent({ type: "response", data: response.data || response });
                    this.markRequestOpenedIfNeeded(response); 
                    resolve(response);
                } else {
                    reject(response)
                }
            }).catch(e => {
                console.error('addSolicitud', e);
                reject(e);
            })
        });
    }

    setNoService(obj) {
        return new Promise((resolve, reject) => {
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + '/requests/sms/no-service', obj).then(d => {
                if(d) {
                    this.sendMessageToParent({ type: "response", data: d.data || d })
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                reject(e);
            })
        });
        
    }

    acceptTerms(obj) {
        return new Promise((resolve, reject) => {
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + '/requests/sms/terms', obj).then(d => {
                if(d) {
                    this.sendMessageToParent({ type: "response", data: d.data || d })
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                reject(e);
            })
        });
    }

    getNewIdOfRequest(id) {
        return new Promise((resolve, reject) => {
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + '/requests/' + id + '/get-new-id', {}).then(d => {
                if(d) {
                    this.sendMessageToParent({ type: "response", data: d.data || d })
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                reject(e);
            })
        });
    }

    checkService(obj) {
        return new Promise((resolve, reject) => {
          this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + '/requests/sms/check-service', obj).then(d => {
              if (d.code === 400) {
                this.sendMessageToParent({ type: "response", data: { ...d.response, status_code: 'no_sms_service' } });
              } else {
                this.sendMessageToParent({ type: "response", data: d.data || d });
              }
              resolve(d);
            }).catch(e => {
              reject(e);
            })
        });
    }

    retryRequest(obj) {
        return new Promise((resolve, reject) => {
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + '/requests/sms/retry' , obj).then(d => {
                if(d) {
                    this.sendMessageToParent({ type: "response", data: d.data || d })
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                reject(e);
            })
        });
    }

    resendOTP(obj) {
        return new Promise((resolve, reject) => {
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + '/requests/sms/resend-otp', obj).then(d => {
                if(d) {
                    this.sendMessageToParent({ type: "response", data: d.data || d })
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                reject(e);
            })
        });
    }

    fixData(request_id, obj) {
        return new Promise((resolve, reject) => {
            this.localFetch.putFetchWhitoutToken(`${this.apiUrlService.baseUrl}/requests/${request_id}/person`, obj).then(d => {
                if(d) {
                    this.sendMessageToParent({ type: "response", data: d.data || d })
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                reject(e);
            })
        });
    }

    sendOTP(obj) {
        return new Promise((resolve, reject) => {
            let url = '/requests/sms/otp';
            if(environment['scraperMock']) {
                url = '/mockscrapper/requests/sms/otp'
            }
            this.localFetch.postFetchWhitoutToken(this.apiUrlService.baseUrl + url, obj).then(d => {
                if(d) {
                    this.sendMessageToParent({ type: "response", data: d.data || d })
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                reject(e);
            })
        });
    }

    uploadFileFromWidget(obj) {
        return new Promise((resolve, reject) => {
            let url = '/documents/upload-files-from-widget';
            this.localFetch.postFileFetchWhitoutToken(this.apiUrlService.baseUrl + url, obj).then(d => {
                if(d) {
                    this.sendMessageToParent({ type: "response", data: d.data || d })
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                reject(e);
            })
        });
    }

    sendLinkBySms(requestID, obj) {
        return new Promise((resolve, reject) => {
            this.localFetch.postFetch(`${this.apiUrlService.baseUrl}/requests/${requestID}/send-link-sms`, obj).then(d => {
                if(d) {
                    this.sendMessageToParent({ type: "response", data: d.data || d })
                    resolve(d);
                } else {
                    reject(d)
                }
            }).catch(e => {
                reject(e);
            })
        });

        
    }

    getDocuments(requestID) {
        return new Promise((resolve, reject) => {
            this.localFetch.getFetch(`${this.apiUrlService.baseUrl}/requests/${requestID}/documents`).then(d => {
                if(d) {
                    this.sendMessageToParent({ type: "response", data: d.data || d })
                    resolve(d);
                } else {
                    reject('No hay archivos asignados a esta solicitud..');
                }
            }).catch(e => {
                reject(e);
            })
        });
    }

    getDocumentsIds(requestID) {
        return new Promise((resolve, reject) => {
            this.localFetch.getFetch(`${this.apiUrlService.baseUrl}/requests/${requestID}/documents-ids-widget`).then(d => {
                if(d) {
                    this.sendMessageToParent({ type: "response", data: d.data || d })
                    resolve(d);
                } else {
                    reject('No hay archivos asignados a esta solicitud..');
                }
            }).catch(e => {
                reject(e);
            })
        });
    }

    cancelRequest(obj, requestType: 'sms' | 'clave-pin') {
      return new Promise((resolve, reject) => {
        this.localFetch.postFetch(this.apiUrlService.baseUrl + `/requests/${requestType}/cancel`, obj).then(d => {
            if(d) {
                this.sendMessageToParent({ type: "response", data: d.data || d })
                resolve(d);
            } else {
                reject(d)
            }
        }).catch(e => {
            reject(e);
        })
      });
    }

    markRequestOpened(requestId: string) {
        return this.localFetch.postFetchWhitoutToken(`${this.apiUrlService.baseUrl}/requests/${requestId}/opened`, {});
    }

    markRequestOpenedIfNeeded(response: any) {
        const data = response?.data || response;

        if (data?.widget_opened === false) {
            this.markRequestOpened(data.request_id);
        }
    }

    sendMessageToParent(obj) {
        window.top.postMessage(obj, "*");
    }
}
